import { theme } from '@theme';
import { FC, useState } from 'react';
import styled from 'styled-components';
import { Icon } from '../../style/Icon';
import { Typography } from '../../style/Typography';

type ModalTitleProps = {
  size?: number;
  color?: string;
  fontWeight?: number;
  iconColor?: string;
  title?: string;
  bgColor?: string;
  showCloseIcon?: boolean;
  showTitleIcon?: boolean;
  titleIconType?: string;
  titleIconClassName?: string;
  hasCustomTitle?: boolean;
  titleComponent?: JSX.Element;
  titleClassName?: string;
  height?: string;
  borderRadius?: string;
  handleIconClick?: () => void;
};

const ModalTitle: FC<ModalTitleProps> = (props) => {
  const [hovered, setHovered] = useState(false);
  const toggleHover = () => setHovered(!hovered);
  return (
    <Wrapper data-testid='modal-title' height={props.height} borderRadius={props.borderRadius}>
      {props.showTitleIcon && (
        <Icon
          type={props.titleIconType ?? ''}
          color={props.color ?? theme.palette.white}
          size={19}
          className={props.titleIconClassName}
        />
      )}
      <Typography
        size={props.size ?? theme.typography.h4}
        color={props.color ?? theme.palette.white}
        fontWeight={props.fontWeight ?? theme.typography.fontWeights.semibold}
        className={`title ${props.titleClassName ?? ''}`}
      >
        {props.title}
      </Typography>
      {props.hasCustomTitle && (
        <div data-testid='custom-title-component'>{props.titleComponent}</div>
      )}
      {props.showCloseIcon && (
        <button
          data-testid='close-button'
          className={hovered ? 'close hovered' : 'close'}
          type='button'
          onClick={props.handleIconClick}
          onMouseEnter={toggleHover}
          onMouseLeave={toggleHover}
        >
          <Icon
            data-testid='close-icon'
            type='x'
            size={theme.typography.h1}
            color={props.iconColor ?? theme.palette.white}
            className='am-icon am-icon-x'
          />
        </button>
      )}
    </Wrapper>
  );
};

export default ModalTitle;

const Wrapper = styled.div<ModalTitleProps>`
  height: ${(props) => props.height ?? ''};
  background-color: ${(props) => props.bgColor ?? theme.palette.text.purple};
  border-top-right-radius: ${(props) => props.borderRadius ?? ''};
  border-top-left-radius: ${(props) => props.borderRadius ?? ''};
  display: flex;

  .am-icon-notes {
    padding: 18px 0px 18px 18px;
  }

  .close {
    cursor: pointer;
    padding: 5px 20px;
    border-left: 1px solid ${theme.palette.translucentPurple};
    border-top: none;
    border-bottom: none;
    border-right: none;
    opacity: 1;
    text-shadow: 0 1px 0 #fff;
    border-top-right-radius: ${(props) => props.borderRadius ?? ''};
    background: transparent;
    &.hovered {
      background: ${theme.palette.hightLightPurple};
    }
  }

  .title {
    padding: 15px 20px;
    width: 90%;
  }

  .dropdowns-wrapper {
    display: flex;
    position: absolute;
    top: 16px;
    right: 80px;

    .am-icon-angle-down {
      right: 10px;
    }
  }
  .modal-title-text {
    flex: 1;
  }
`;
